import {Component, OnInit} from '@angular/core';
import {EQOColor, EQOIcon, EQORebrandColor, EQORebrandIcon} from '@quickorder/angular-web-lib';
import {MatDialog} from '@angular/material/dialog';
import {Store} from '@ngrx/store';
import {IAppState} from '@app/core/store/state/app.state';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-email-exists-popup',
	templateUrl: './email-exists-popup.component.html',
	styleUrls: ['./email-exists-popup.component.scss'],
})
export class EmailExistsPopupComponent implements OnInit {
	public ICON = EQOIcon;
	public EQORebrandIcon: typeof EQORebrandIcon = EQORebrandIcon;
	public EQORebrandColor: typeof EQORebrandColor = EQORebrandColor;

	public products: {
		name: string,
		url: string,
		icon: string,
	}[] = [
		{
			name: this.translate.instant('GLOBAL.POS'),
			url: 'https://my.shopbox.com',
			icon: 'assets/icons/pos_icon_green.svg',
		},
		{
			name: this.translate.instant('GLOBAL.SCHEDULING'),
			url: 'https://shifts.shopbox.com',
			icon: 'assets/icons/manager-icon-green.svg',
		}
	];

	constructor(
		public dialog: MatDialog,
		private store: Store<IAppState>,
		private translate: TranslateService,
	) {
	}

	public ngOnInit(): void {
	}

	public productClicked(url: string): void {
		window.open(url, '_blank');
	}

}
